/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserPreferenceDeleteRequest {
    getFixupPrototypeFunction() { return UserPreferenceDeleteRequest.fixupPrototype; }

    static newInstance(model: Partial<UserPreferenceDeleteRequest>): UserPreferenceDeleteRequest {
        let obj = Object.assign(new UserPreferenceDeleteRequest(), model);
        UserPreferenceDeleteRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserPreferenceDeleteRequest>): UserPreferenceDeleteRequest {
        if (!model) return null;
        return UserPreferenceDeleteRequest.newInstance(<UserPreferenceDeleteRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserPreferenceDeleteRequest) {
        if (!obj) return;

        models.UserPreferenceDeleteRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserPreferenceDeleteRequest): boolean {
        Object.setPrototypeOf(obj, UserPreferenceDeleteRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Path of the user preference
     */
    path: string;

    /**
     * Name of the user preference
     */
    name: string;

}
